<template>
  <div class="add-sub-plan-admin" v-if="currentUser">
    <div class="page-header">
      <h1>Dodaj plan</h1>
      <button class="btn-outline" @click="$router.push('/admin-profile/price-list')">Wróć do cennika</button>
    </div>

    <div class="section-card position-relative">
      <div class="section-card-header">
        <HintComponent page-key="admin_panel_add_sub_plan" :absolute="true"/>
        <h2>Nowy plan subskrypcji</h2>
        <p class="section-subtitle">
          Uzupełnij pola, aby dodać nowy plan do cennika.
        </p>
      </div>

      <form class="plan-form" @submit.prevent="addSubPlan">
        <div class="form-grid">
          <div class="form-group full">
            <label for="name">Nazwa planu</label>
            <input type="text" id="name" v-model="newSubData.name" name="name" required>
          </div>

          <div class="form-group">
            <label for="subscription">Opłata abonamentowa (na miesiąc)</label>
            <input type="number" step="0.01" v-model="newSubData.subscriptionM" id="subscription" name="subscription" required>
          </div>

          <div class="form-group">
            <label for="additionalUser">Opłata za dodatkowego użytkownika (na miesiąc)</label>
            <input type="number" step="0.01" v-model="newSubData.additionalUserM" id="additionalUser" name="additionalUser" required>
          </div>

          <div class="form-group">
            <label for="additionalSMS">Opłata za wysłanie SMS-a (w zł)</label>
            <input type="number" step="0.01" v-model="newSubData.additionalSMS" id="additionalSMS" name="additionalSMS" required>
          </div>

          <div class="form-group">
            <label for="freeUsers">Ilość darmowych użytkowników</label>
            <input type="number" v-model="newSubData.freeUsers" id="freeUsers" name="freeUsers" required>
          </div>

          <div class="form-group">
            <label for="freeSMS">Ilość darmowych SMS-ów</label>
            <input type="number" v-model="newSubData.freeSMS" id="freeSMS" name="freeSMS" required>
          </div>

          <div class="form-group">
            <label for="period">Czas trwania subskrypcji (w miesiącach)</label>
            <input type="number" v-model="newSubData.period" id="period" name="period" required>
          </div>
        </div>

        <div class="info-note">
          W cenniku wyświetlana będzie kwota pomnożona przez podaną liczbę miesięcy.
        </div>

        <div class="form-actions">
          <button type="button" class="btn-outline" @click="$router.push('/admin-profile/price-list')">Anuluj</button>
          <button type="submit" class="btn-primary">Dodaj plan</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'AddSubPlan',
  components: {HintComponent},
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      newSubData: {
        name: '',
        subscriptionM: '',
        additionalUserM: '',
        additionalSMS: '',
        freeUsers: '',
        freeSMS: '',
        period: '',
      },
    };
  },
  props: ['isVisible'],
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
  },
  methods: {
    addSubPlan() {
      axios.post('/Subscription', this.newSubData, authHeader()).then(() => {
        this.appStore.setIsSuccess('Pomyślnie dodano plan');
        this.$router.push('/admin-profile/price-list');
      }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.add-sub-plan-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 18px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 1.4rem;
}

.plan-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 12px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group.full {
  grid-column: 1 / -1;
}

.form-group label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.form-group input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  color: #1f2937;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  width: 100%;
}

.form-group input:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.12);
}

.info-note {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  color: #6b7280;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.35rem;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 900px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .add-sub-plan-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .form-actions {
    flex-direction: column;
  }

  .btn-primary,
  .btn-outline {
    width: 100%;
    text-align: center;
  }
}
</style>